import styled from 'styled-components';

import { RichText } from 'components/Text/RichText';
import { CmsApiFreeCodeBlockData } from 'modules/cms/api/types/blocks/CmsApiFreeCodeBlock';

import emailSignupBlock from './emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlock}
`;

type Props = {
  data: CmsApiFreeCodeBlockData;
};

export function CmsFreeCodeBlock({ data: { code } }: Props) {
  return (
    <StyledRichText
      dangerouslySetInnerHTML={{
        __html: code,
      }}
      tag="section"
    />
  );
}
